var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExpireHeader',{attrs:{"header":"สินค้าคืนไม่ได้รอย้ายเข้าคลังทิ้ง","img_header":_vm.header_image,"link_back":"stock/storage/expirestorage"}}),_c('Drop_product')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }